module.exports = __webpack_public_path__ + "img/1.63b127c2.jpg";